module.exports = __webpack_public_path__ + "b8ec8e39b7f3dfd5c0c900e0a58ff3cb.svg";